import { resolveUpdate } from './resolve';

export const createUsersSlice = (set) => ({
  adminUsers: [],
  setAdminUsers: (suivant) =>
    set((etat) => ({ adminUsers: resolveUpdate(suivant, etat.adminUsers) })),
  adminUsersLoading: false,
  setAdminUsersLoading: (suivant) =>
    set((etat) => ({ adminUsersLoading: resolveUpdate(suivant, etat.adminUsersLoading) })),
  newUserForm: {
    nom: '',
    prenom: '',
    email: '',
    role: 'dev',
    typeContrat: 'CDI',
    disponibilite: 5,
    coutHoraire: '',
    joursTravailles: [],
    isCongesValidator: false,
  },
  setNewUserForm: (suivant) =>
    set((etat) => ({ newUserForm: resolveUpdate(suivant, etat.newUserForm) })),
  newUserError: '',
  setNewUserError: (suivant) =>
    set((etat) => ({ newUserError: resolveUpdate(suivant, etat.newUserError) })),
  newUserSuccess: '',
  setNewUserSuccess: (suivant) =>
    set((etat) => ({ newUserSuccess: resolveUpdate(suivant, etat.newUserSuccess) })),
  showNewUserModal: false,
  setShowNewUserModal: (suivant) =>
    set((etat) => ({ showNewUserModal: resolveUpdate(suivant, etat.showNewUserModal) })),
});
